import { createI18n } from 'vue-i18n'
import fr from '@/locales/fr.json'
import en from '@/locales/en.json'

const VALID_LOCALES = ['fr', 'en']
const stored = localStorage.getItem('bo_locale')
const savedLocale = VALID_LOCALES.includes(stored) ? stored : 'en'

if (!stored) localStorage.setItem('bo_locale', 'en')

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: { fr, en },
})

export default i18n

export const currentLocale = i18n.global.locale

export function setLocale(lang) {
  i18n.global.locale.value = lang
  localStorage.setItem('bo_locale', lang)
}
